/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BillingTransactionHistory } from '../models/BillingTransactionHistory';
import { Provider } from '../models/Provider';
import { TimeFrame } from '../models/TimeFrame';

/**
* Response containing billing transaction history
*/
export class GetBillingTransactionHistoryResponse {
  'cloudProvider': Provider;
  'timeFrame': TimeFrame;
  /**
  * Array of billing transaction records matching the requested query criteria.
  */
  'transactions': Array<BillingTransactionHistory>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "timeFrame",
      "baseName": "timeFrame",
      "type": "TimeFrame",
      "format": ""
    },
    {
      "name": "transactions",
      "baseName": "transactions",
      "type": "Array<BillingTransactionHistory>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetBillingTransactionHistoryResponse.attributeTypeMap;
  }

  public constructor() {
  }
}



